// types
import type { SessionUserPreference } from '../RosterPlan.types';

const SESSION_STORAGE_KEY = 'userPreferences';

/**
 * The preferences the session already holds, always as a list.
 *
 * The fallback is `[]` rather than `{}`: callers filter over the result, and an object has no
 * `.filter`, so the old fallback threw a TypeError on the first toggle of a session that had never
 * written the key. A value that parses to something other than a list is treated the same way,
 * since it cannot be filtered either.
 */
export const readSessionUserPreferences = (): SessionUserPreference[] => {
  const stored = JSON.parse(
    sessionStorage.getItem(SESSION_STORAGE_KEY) || '[]'
  );

  return Array.isArray(stored) ? stored : [];
};

/** Replaces one preference in the session copy, leaving the others as they are. */
export const writeSessionUserPreference = ({
  key,
  value
}: SessionUserPreference) => {
  const others = readSessionUserPreferences().filter(
    (preference) => preference.key !== key
  );

  sessionStorage.setItem(
    SESSION_STORAGE_KEY,
    JSON.stringify([...others, { key, value }])
  );
};
